import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Overlay from 'core/components/Overlay';
import Close from 'core/icons/Close';

import {
	Title,
	Header,
	ModalWrapper,
	DismissBtn,
	BodyContent,
} from 'core/styles/modal';

class Modal extends PureComponent {
	render() {
		const {
			open, onClose, title, children, noOverflow, noHeader,
			maxWidth, clean, footer, id, fromBottom, bodyFlex,
		} = this.props;
		if (!open) return null;

		const wrapperProps = {};
		if (id) wrapperProps.id = id;
		if (maxWidth) wrapperProps.maxWidth = maxWidth;

		return (
			<Overlay noCloseBtn dismiss={onClose} noOverflow={noOverflow} fromBottom={fromBottom}>
				<ModalWrapper {...wrapperProps}>
					{!noHeader && (
						<Header clean={clean}>
							<Title>{title}</Title>
							<DismissBtn onClick={onClose} clean={clean}>
								<Close width={20} height={20} fill={'currentColor'} stroke={'white'} />
							</DismissBtn>
						</Header>
					)}
					<BodyContent clean={clean} $flex={bodyFlex}>
						{children}
					</BodyContent>
					{footer && <>{footer}</>}
				</ModalWrapper>
			</Overlay>
		);
	}
}

Modal.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	title: PropTypes.node,
	children: PropTypes.node.isRequired,
	noOverflow: PropTypes.bool,
	noHeader: PropTypes.bool,
	clean: PropTypes.bool,
	bodyFlex: PropTypes.number,
	footer: PropTypes.node,
	id: PropTypes.string,
	maxWidth: PropTypes.string,
	fromBottom: PropTypes.bool,
};

Modal.defaultProps = {
	onClose: () => null,
};

export default Modal;
